/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { moneyFixed, twoDecimal } from '@/tools/money';
import { payStatusRender } from '@/page/settlementCenter/utils';

export default {
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  fullName: {
    label: '项目参与人',
    prop: 'fullName'
  },
  userPhone: {
    label: '手机号',
    prop: 'userPhone'
  },
  bankNo: {
    label: '收款账号',
    prop: 'bankNo'
  },
  collectMoneyType: {
    label: '收款方式',
    prop: 'collectMoneyType',
    formatter(r, c, v) {
      return { 1: '银行卡', 2: '钱包' }[v] || '-';
    }
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName'
  },
  taskDt: {
    label: '任务月度',
    prop: 'taskDt'
  },
  supplierName: {
    label: '供应商',
    prop: 'supplierName'
  },
  finishSum: {
    label: '实际完成任务量',
    prop: 'finishSum'
  },
  taskPrice: {
    label: '终端结算单价',
    prop: 'taskPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  finishSumTaskPrice: {
    label: '终端结算金额',
    prop: 'finishSumTaskPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  commission: {
    label: '服务费率',
    prop: 'commission',
    formatter(r, c, v) {
      return twoDecimal(v, 100, '%');
    }
  },
  totalPrice: {
    label: '结算总价',
    prop: 'totalPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  payStatus: {
    label: '支付状态',
    prop: 'payStatus',
    formatter(r) {
      return payStatusRender(r, 3);
    }
  },
  finishPayDt: {
    label: '到账时间',
    prop: 'finishPayDt'
  },
  endPointFinishPayDt: {
    label: '终端到账时间',
    prop: 'endPointFinishPayDt'
  }
};
